module.exports = __webpack_public_path__ + "static/img/rhhdsy.3c4b910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rhhdsy.png
// module id = Pn03
// module chunks = 1